<script setup>
import { ref } from 'vue';
import SuccessConfirmationModal from '../modals/SuccessConfirmationModal.vue';
import SuccessModal from '../modals/SuccessModal.vue';

const emit = defineEmits(['close', 'confirm']);
const showSuccessModal = ref(false);

const handleConfirm = () => {
  emit('confirm');
  showSuccessModal.value = true;
};
</script>

<template>
  <SuccessConfirmationModal
    v-if="!showSuccessModal"
    @close="emit('close')"
    @confirm="handleConfirm"
  />

  <SuccessModal
    v-else
    @close="emit('close')"
  />
</template>
